import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useSearchSkuByKeyword = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/master-variation/list", {
        page: 0,
        size: 100,
        keywordType: params?.keywordType ? params?.keywordType : "SKU_IG_CASE",
        keyword: params.sku || ""
      });
      let resultData = [];
      if (res && res.data) {
        if (Array.isArray(res.data.content)) {
          resultData = res.data.content;
        }
      }
      setData(resultData);
      return resultData;
    } catch (error) {
      handleError(error);
      return [];
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    data,
    setData,
    fetchData
  };
};
